import View from './SectionHeader'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const SectionHeader = connect(mapStateToProps)(View)

export default SectionHeader
